import { render, staticRenderFns } from "./agency_role.vue?vue&type=template&id=1d371e8a&scoped=true&"
import script from "./agency_role.vue?vue&type=script&lang=js&"
export * from "./agency_role.vue?vue&type=script&lang=js&"
import style0 from "./agency_role.vue?vue&type=style&index=0&id=1d371e8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d371e8a",
  null
  
)

export default component.exports